<template>
	<div>
		<div class="cont">
			<Breadcrumb :pathList="pathList"></Breadcrumb>
			<div class="flex-only" style="margin-top: 20px;">
				<el-image style="width: 320px;height: 183px;border-radius: 13px;" :src="artDeail.img" :preview-src-list="$getImageList(artDeail.img)">
				</el-image>
				<div class="right flex-1">
					<div class="name">{{artDeail.title}}</div>
					<div class="det">
						{{artDeail.detail}}
					</div>
				</div>
			</div>
			<div class="t" style="margin-top: 20px;" v-html="artDeail.desc"></div>
			<!-- <div class="titles">关于放电电源装置</div>
			<div class="t">
				沙迪克的开发历史最早源于作为放电加工机的心脏的放电电源装置的开发。放电加工是指在电极间以绝缘液为媒介，向两个电极（加工用的电极和被加工物）施加电压的同时使两个电极的距离逐渐接近，发生放电的状态。放电的能量在熔化，气化加工物的同时，根据放电产生的高电压，加工物材料从放电发生的部分开始被流吹走。通过此现象在1秒间几万，几十万的重复，进行着放电加工。
			</div>
			<div class="titles">优点</div>
			<div class="t">通过控制放电能量的供给方法、供给时间、电极间距离，能够控制放电脉冲，发挥出所期待的放电加工性能。</div>
			<div class="tit">线切割放电加工</div>
			<div class="tit2">采用最新设备的“Smart Pulse”放电控制装置，以压倒性的性能实现了高速加工和高精度加工的共存。</div>
			<ul>
				<li>1纳秒间产生稳定的1000A以上的高峰电流（TM回路）</li>
				<li>1st加工中大幅度提高垂直精度的“无拱控制”（无拱控制）</li>
				<li>1st加工中大幅度提高垂直精度的“无拱控制”（无拱控制）</li>
				<li>超高频率数字脉冲的精加工回路（Digital-PIKA-W回路）</li>
			</ul>

			<div class="tit">电火花放电加工</div>
			<div class="tit2">能够在1微秒到数微秒之间正确地重复发生从1至数A程度的电流，得到高品质的精加工面（SVC回路）</div>
			<ul>
				<li>能够稳定地重复发生数十微秒到数毫秒的较长电流脉冲（电极无消耗回路）</li>
				<li>实现镜面加工（PIKA回路）</li>
				<li>防止异常弧放电，实现高速加工的稳定放电加工系统（无弧PLUS）</li>
			</ul> -->
		</div>
		<toTop></toTop>
		<Footer></Footer>
	</div>
</template>

<script>
	import {
		getArtDeatil
	} from "@/api/common";
	import Breadcrumb from '../../components/Breadcrumb.vue'
	import Footer from '../../components/Footer.vue'
	import toTop from '../../components/toTop.vue'
	export default {
		data() {
			return {
				pathList: [{
					title: '首页',
					path: '/index'
				}, {
					title: '核心技术',
					path: '/telenology'
				}, {
					title: '核心详情',
					path: ''
				}],
				id: '',
				artDeail:''

			}
		},
		components: {
			Breadcrumb,
			Footer,
			toTop,
		},
		mounted() {
			this.id = this.$route.query.id
			this.getArtDeatil()
		},
		methods: {
			async getArtDeatil() {
				const {
					data,
					status
				} = await getArtDeatil({
					uuid: this.id
				})
				this.artDeail = data.result
			},
			currentChange(e) {
				console.log(e)
			}
		}
	}
</script>

<style lang="less" scoped>
	::v-deep p{
		font-family: HONOR Sans CN, HONOR Sans CN;
		font-weight: 400 !important;
		font-size: 16px !important;
		color: #666666 !important;
	}
	.cont {
		padding: 30px 133px 0;
		.right {
			margin-left: 20px;

			.name {
				margin-top: 20px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 600;
				font-size: 18px;
				color: #333333;
			}

			.det {
				margin-top: 20px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #999999;
			}
		}

		.t {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #666666;
		}

		.tit {
			margin: 20px 0 10px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 500;
			font-size: 22px;
			color: #000000;
		}

		.tit2 {
			margin-bottom: 10px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 18px;
			color: #333333;
		}

		ul {
			li {
				line-height: 30px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #666;
			}
		}
	}
	
	::v-deep img{
		width: 100%;
	}
</style>